/**
 * AI Safety Assistant Page
 * Full-page AI chatbot experience
 */
import AIChatbot from '@/components/AIChatbot';
import { useTranslation } from 'react-i18next';

export default function AIChatbotPage({ onNavigate }) {
  const { t } = useTranslation();
  return (
    <div className="p-6" data-testid="ai-assistant-page">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
          {t('ai.title')}
        </h1>
        <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
          {t('ai.subtitle')}
        </p>
      </div>
      
      <AIChatbot isFullPage={true} isOpen={true} onNavigate={onNavigate} />
    </div>
  );
}
